import type { ContentStatusFilterType } from 'components/search-content/components/search-content-filters/components/status-filter/StatusFilter';
import { ItpIssueStatus } from 'data/generated/graphql';

export const DEFAULT_CONTENT_SEARCH_FILTERS = {
  contentTypes: [''],
  author: '',
  embargo: false,
  publishDates: {
    beforeUtc: null,
    afterUtc: null
  },
  contentStatuses: new Set<ContentStatusFilterType>(['PUBLISHED'])
};

export const ITP_STATUS_COLOR: Record<ItpIssueStatus, 'gray' | 'sunshine' | 'emerald' | 'lava'> = {
  [ItpIssueStatus.Draft]: 'gray',
  [ItpIssueStatus.Changed]: 'sunshine',
  [ItpIssueStatus.Published]: 'emerald',
  [ItpIssueStatus.Deleted]: 'lava'
};

export const NUMBER_OF_PREVIOUS_PUBLISHED_CONTENT_TO_SHOW = 5;
export const NUMBER_OF_PUBLISHED_CONTENT_TIMESTAMPS_TO_SHOW = 100;
export const PUBLISH_HISTORY_PREFETCH_THRESHOLD = 3;

export const MULTIZONE_MODULE = 'MultiZoneModule';

export const MOBILE_ARTICLE = 'MobileArticle';

export const MOBILE_LINKED_ITEM = 'MobileLinkedItem';

export const GRAPHIC_LINKED_ITEM = 'GraphicLinkedItem';

export const SECTION_NAME_OVERRIDE: Record<string, string> = {
  'CN-Opinion': 'opinion'
};

export const DEFAULT_SUBNAV_WRAPPER_HEIGHT = 40;
export const DEFAULT_PAGE_TITLE_HEIGHT = 72;

export const PAGE_UPDATE_THREAD_PREFIX = 'PAGEUPDATES#';
export const PAGE_LOCK_THREAD_PREFIX = 'LOCKSTATE#';
export const LOCK_PAYLOAD_VERSION = 1;

export const RIBBON_REGEX = /^https:\/\/(asset\.wsj\.net|wsj-s3-proxy-int\.sc\.onservo\.com)\/.+/;

// Update this list whenever a field is added to or removed from the Edit Alt-Summ modal.
// It drives both the "Disabled Alt-Summ Fields" MultiSelect in publication settings
// and the Set used in AltSummModal to conditionally hide fields.
export const ALT_SUMM_FIELDS = [
  'flashline',
  'headline',
  'body',
  'bullets',
  'image',
  'video',
  'chart',
  'iframe'
] as const;

export type AltSummField = (typeof ALT_SUMM_FIELDS)[number];

const DOMAIN_BY_ENV: Record<string, string> = {
  dev: 'https://@.dev.dowjones.io',
  int: 'https://@.int.dowjones.io',
  prd: 'https://@.dowjones.io'
};

const BASE_DOMAIN = DOMAIN_BY_ENV[process.env.REACT_APP_OKTA_ENV ?? ''] || DOMAIN_BY_ENV.dev;

export const IMAGE_MANAGER_DOMAIN = BASE_DOMAIN.replace('@', 'images');

export const CHARTS_DOMAIN = BASE_DOMAIN.replace('@', 'charts');
